export default __webpack_public_path__ + "static/media/glade_chick.28d3aedb.png";